import { SLIPPAGE_BPS_MIN, SLIPPAGE_BPS_MAX } from "@repo/constants";
import { z } from "zod";
import { VaultOperationSchema } from "./bound-contract";
import { validateVaultOperationCall } from "./bound-call";
const AddressSchema = z.string().regex(/^0x[a-fA-F0-9]{40}$/);
const slippageBpsSchema = z
  .number()
  .int()
  .min(SLIPPAGE_BPS_MIN)
  .max(SLIPPAGE_BPS_MAX)
  .optional();
const RebalanceBatchCallSchema = z
  .object({
    kind: z.enum([
      "approve",
      "sign_permit2",
      "withdraw",
      "swap",
      "deposit",
      "sweep",
      "ondo_direct_batch_rebalance",
    ]),
    assetId: z.string().min(1),
    amountRaw: z.string().min(1),
    minOutRaw: z.string().min(1).optional(),
    spender: AddressSchema.optional(),
    yieldSourceId: z.string().min(1).optional(),
    tokenOut: z.string().min(1).optional(),
    nodeRef: z.string().min(1),
    issuerArgs: z.record(z.string(), z.unknown()).optional(),
  })
  .strict();

export const RebalanceBatchArgsSchema = z
  .object({
    vaultOperation: VaultOperationSchema.optional(),
    waveIndex: z.number().int().nonnegative(),
    adapterId: z.string().min(1),
    calls: z.array(RebalanceBatchCallSchema).min(1),
    slippageBps: slippageBpsSchema,
    aggregatorProvider: z.enum(["lifi", "relay", "uniswap_v3"]).optional(),
  })
  .superRefine((args, ctx) => {
    const message = validateVaultOperationCall(args);
    if (message) ctx.addIssue({ code: "custom", message });
  });
export type RebalanceBatchInputArgs = z.infer<typeof RebalanceBatchArgsSchema>;
